import { createStaleWhileRevalidateCache } from 'stale-while-revalidate-cache'

const swr = (typeof window !== 'undefined')&&createStaleWhileRevalidateCache({
  storage: window.localStorage, // can be any object with getItem and setItem methods
  minTimeToStale: 5000, // 5 seconds
  serialize: JSON.stringify, // serialize product object to string
  deserialize: JSON.parse, // deserialize cached product string to object
})

export default swr;